export default __webpack_public_path__ + "static/media/MB.75749ba2.jpg";